mutation UpdateEmployeeTrainingFields(
  $employeeIds: [ID!]!
  $trainingRequired: Boolean
  $startDate: ISO8601Date
  $teamId: ID
) {
  updateEmployeeTrainingFields(
    input: {
      employeeIds: $employeeIds
      trainingRequired: $trainingRequired
      startDate: $startDate
      teamId: $teamId
    }
  ) {
    assignedCount
    employees {
      id
    }
  }
}
